export default __webpack_public_path__ + "static/media/streamers.744d7a5f.gif";